"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Button: true,
  EksempelKomponent: true,
  DropDownList: true,
  DateTime: true,
  getDateTime: true,
  DateString: true,
  Time: true,
  NumberFormat: true,
  getNumberFormat: true,
  DateRangePicker: true,
  subDays: true,
  subWeeks: true,
  subMonths: true,
  subYears: true,
  addDays: true,
  addWeeks: true,
  addMonths: true,
  addYears: true,
  format: true,
  parse: true,
  LinkCard: true
};
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});
Object.defineProperty(exports, "EksempelKomponent", {
  enumerable: true,
  get: function get() {
    return _EksempelKomponent.default;
  }
});
Object.defineProperty(exports, "DropDownList", {
  enumerable: true,
  get: function get() {
    return _DropDownList.default;
  }
});
Object.defineProperty(exports, "DateTime", {
  enumerable: true,
  get: function get() {
    return _DateTime.default;
  }
});
Object.defineProperty(exports, "getDateTime", {
  enumerable: true,
  get: function get() {
    return _DateTime.getDateTime;
  }
});
Object.defineProperty(exports, "DateString", {
  enumerable: true,
  get: function get() {
    return _DateString.default;
  }
});
Object.defineProperty(exports, "Time", {
  enumerable: true,
  get: function get() {
    return _Time.default;
  }
});
Object.defineProperty(exports, "NumberFormat", {
  enumerable: true,
  get: function get() {
    return _NumberFormat.default;
  }
});
Object.defineProperty(exports, "getNumberFormat", {
  enumerable: true,
  get: function get() {
    return _NumberFormat.getNumberFormat;
  }
});
Object.defineProperty(exports, "DateRangePicker", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.default;
  }
});
Object.defineProperty(exports, "subDays", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.subDays;
  }
});
Object.defineProperty(exports, "subWeeks", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.subWeeks;
  }
});
Object.defineProperty(exports, "subMonths", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.subMonths;
  }
});
Object.defineProperty(exports, "subYears", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.subYears;
  }
});
Object.defineProperty(exports, "addDays", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.addDays;
  }
});
Object.defineProperty(exports, "addWeeks", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.addWeeks;
  }
});
Object.defineProperty(exports, "addMonths", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.addMonths;
  }
});
Object.defineProperty(exports, "addYears", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.addYears;
  }
});
Object.defineProperty(exports, "format", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.format;
  }
});
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker.parse;
  }
});
Object.defineProperty(exports, "LinkCard", {
  enumerable: true,
  get: function get() {
    return _LinkCard.default;
  }
});

var _Button = _interopRequireDefault(require("./components/Button"));

var _EksempelKomponent = _interopRequireDefault(require("./components/EksempelKomponent"));

var _DropDownList = _interopRequireDefault(require("./components/DropDownList"));

var _DateTime = _interopRequireWildcard(require("./components/DateTime"));

var _DateString = _interopRequireDefault(require("./components/DateString"));

var _Time = _interopRequireDefault(require("./components/Time"));

var _NumberFormat = _interopRequireWildcard(require("./components/NumberFormat"));

var _DateRangePicker = _interopRequireWildcard(require("./components/DateRangePicker"));

var _icons = require("./components/icons");

Object.keys(_icons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _icons[key];
    }
  });
});

var _LinkCard = _interopRequireDefault(require("./components/LinkCard"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}